export const FIELD_NAME = 'answer';

export const MAX_LENGTH = 500;
